export default __webpack_public_path__ + "static/media/Girdle of the Howling Giant.234abdff.jpg";